import {
	cookieWrite,
	getAkeyV3,
	isApppassApp,
	isAumarketApp,
	isFromOutside,
	isSmartpassApp,
	isSugotokuApp,
	isWebview,
	isWniApp,
	nocache,
	readCookie,
} from "./common.js";

const premiumCookieSet = {
	d1: { status300: 0, status100: 1, status_smartpass: 0 },
	d3: { status300: 1, status100: 0, status_smartpass: 0 },
	c3: { status300: 1, status100: 0, status_smartpass: 0 },
	k1: { status300: 0, status100: 1, status_smartpass: 0 },
	k3: { status300: 1, status100: 0, status_smartpass: 0 },
	k3k1: { status300: 1, status100: 1, status_smartpass: 0 },
	l1: { status300: 0, status100: 1, status_smartpass: 0 },
	l3: { status300: 1, status100: 0, status_smartpass: 0 },
	b3: { status300: 0, status100: 0, status_smartpass: 0 },
	b3k3: { status300: 1, status100: 0, status_smartpass: 0 },
	b3l3: { status300: 1, status100: 0, status_smartpass: 0 },
	b3l1: { status300: 0, status100: 1, status_smartpass: 0 },
	a3: { status300: 1, status100: 0, status_smartpass: 0 },
};

/**
 * APIを利用した認証chk_akey の中から呼び出される
 *     一度問い合わせたキーはキャッシュさせている
 * @param {String} akey - 認証キー
 * @return {Promise} promise - resolve: 認証成功, reject: 認証失敗
 * @name wniutil.auth#chk_akey_cache
 * @private
 * @function
 */
const checkAkeyByApi = (() => {
	const cache = {};
	return (akey) => {
		const authKey = akey || getAkeyV3();
		if (!cache[authKey]) {
			const url = new URL("https://aplapi.weathernews.jp/lba/prof/chk_id");
			url.searchParams.set("akey", authKey);
			url.searchParams.set("t", nocache);
			cache[authKey] = fetch(url).then((res) => res.json());
		}
		return cache[authKey];
	};
})();

/**
 * APIを利用した認証
 *     一度問い合わせたキーをキャッシュさせるため、内部的にcheckAkeyByApi を呼び出している
 * @param {String} akey - 認証キー
 * @return {Promise} promise - resolve: 認証成功, reject: 認証失敗
 * @name wniutil.auth#chk_akey
 * @function
 */
export const checkAkey = (akey) => {
	return new Promise((resolve, reject) => {
		const authKey = akey || getAkeyV3();
		if (authKey) {
			checkAkeyByApi(authKey)
				.then((res) => {
					if (res.status.auth === "OK") {
						resolve("api");
					} else {
						reject(p.status.reason);
					}
				})
				.catch(reject);
		} else {
			reject("no akey");
		}
	});
};

/**
 * CookieおよびAPIを利用した認証
 * @param {String} akey - 認証キー
 * @return {Promise} promise - resolve: 認証成功, reject: 認証失敗
 * @name wniutil.auth#chk_premium
 * @function
 */
export const checkPremium = async (akey) => {
	const params = new URLSearchParams(location.search);
	const cookies = readCookie();
	if (isWebview()) {
		if (params.get("is_premium") === "1") {
			cookieWrite("is_app_premium", "1", 1 / 24);
			return "is_premium";
		}
		if (cookies.is_app_premium === "1") {
			return "is_app_premium";
		}
		if (params.is_premium === "0") {
			cookieWrite("is_app_premium", "0", 1 / 24);
			throw new Error("is_premium");
		}
		if (cookies.is_app_premium === "0") {
			throw new Error("is_app_premium");
		}
	}

	if (isP1()) {
		return cookies.premium; // cookieのみで有料確定
	}

	const authKey = akey || getAkeyV3();
	return await checkAkey(authKey);
};

/**
 * Cookieから300円会員かどうかを確認する関数
 * @return {Boolean}
 * @private
 * @function
 */
const isP3 = () => {
	const cookies = readCookie();
	const key = cookies.premium;
	if (key in premiumCookieSet) {
		return premiumCookieSet[key].status300 === 1;
	}
	return false;
};

/**
 * Cookieから100円会員以上かどうかを確認する関数
 * @return {Boolean}
 * @private
 * @function
 */
const isP1 = () => {
	const cookies = readCookie();
	const key = cookies.premium;
	if (key in premiumCookieSet) {
		return premiumCookieSet[key].status300 === 1 || premiumCookieSet[key].status100 === 1;
	}
	return false;
};

/**
 * Cookieから無料会員かどうかを確認する関数
 * @return {Boolean}
 * @private
 * @function
 */
export const isFree = () => {
	const cookies = readCookie();
	const key = cookies.premium;
	return !isP1(key);
};

/**
 * Cookieから100円会員かどうかを確認する関数
 * @return {Boolean}
 * @private
 * @function
 */
export const is100 = () => {
	const cookies = readCookie();
	const key = cookies.premium;
	if (key in premiumCookieSet) {
		return premiumCookieSet[key].status100 === 1;
	}
	return false;
};

/**
 * Cookieからスマートパス円会員かどうかを確認する関数
 * @return {Boolean}
 * @private
 * @function
 */
export const isSmartpass = () => {
	return false; // always return false
};

/**
 * 広告を表示するべきか否かを判定する関数
 * @param {Object} [opt] - オプション
 * @param {Boolean} [opt.use_referer] - リファラーを判定基準に入れるかどうか
 * @returns {Promise<Boolean>} - 広告を表示するか否か
 * @function
 */
export const checkAdsHide = async (opt = {}) => {
	if (opt.ua === undefined) {
		opt.ua = navigator.userAgent;
	}
	if (isSugotokuApp(opt.ua) || isAumarketApp(opt.ua) || isApppassApp(opt.ua)) {
		return true;
	}
	if (isWniApp(opt.ua)) {
		try {
			await checkPremium(opt.akey);
			return true;
		} catch {
			return false;
		}
	} else if (opt.useReferrer && isFromOutside(opt.ref)) {
		return true;
	} else {
		try {
			await checkPremium(opt.akey);
			return true;
		} catch {
			return false;
		}
	}
};
